import { render, staticRenderFns } from "./Medias.vue?vue&type=template&id=2e38538e&scoped=true&lang=pug"
import script from "./Medias.vue?vue&type=script&lang=js"
export * from "./Medias.vue?vue&type=script&lang=js"
import style0 from "./Medias.vue?vue&type=style&index=0&id=2e38538e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e38538e",
  null
  
)

export default component.exports